export const removeOpenModalFromUrl = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);

  if (url.searchParams.has('openModal')) {
    url.searchParams.delete('openModal');
    window.history.replaceState({}, '', url.toString());
  }
};
